"use client";

import { useNavigate } from "react-router";
import Icon from "../components/Icon";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Container } from "react-bootstrap";

export default function TermsPage() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container fluid>
            <Row>
                <Col>
                    <div className="mt-4 mb-5">
                        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                            <h2 className="mb-0">Пользовательское соглашение</h2>
                            <button
                                className="btn btn-outline-secondary"
                                onClick={handleGoBack}
                                aria-label="Вернуться назад"
                            >
                                <Icon icon={faTimes} />
                            </button>
                        </div>

                        <div className="mb-3 text-muted">
                            <strong>Дата вступления в силу:</strong> 25.07.2026
                        </div>

                        <p>
                            Настоящее Пользовательское соглашение (далее — <strong>Соглашение</strong>) регулирует отношения между владельцем сервиса «Артефакты» (далее — <strong>Оператор</strong>) и пользователем сервиса (далее — <strong>Пользователь</strong>).
                        </p>
                        <p>
                            Используя Сервис, Пользователь подтверждает, что ознакомился с настоящим Соглашением и принимает его условия в полном объеме.
                        </p>

                        <h3>1. Термины</h3>
                        <ul>
                            <li><strong>Сервис</strong> — программное обеспечение «Артефакты», доступное через веб-интерфейс и иные программные средства.</li>
                            <li><strong>Пользователь</strong> — физическое лицо, зарегистрировавшее учетную запись в Сервисе.</li>
                            <li><strong>Аккаунт</strong> — учетная запись Пользователя.</li>
                            <li><strong>Подписка</strong> — предоставление доступа к дополнительным функциям Сервиса на определенный срок после оплаты.</li>
                        </ul>

                        <h3>2. Предмет соглашения</h3>
                        <p>Оператор предоставляет Пользователю право использования Сервиса на условиях настоящего Соглашения.</p>
                        <p>Сервис предназначен для:</p>
                        <ul>
                            <li>постановки целей;</li>
                            <li>стратегического планирования;</li>
                            <li>ведения задач;</li>
                            <li>управления временем;</li>
                            <li>хранения пользовательских данных;</li>
                            <li>анализа личной эффективности;</li>
                            <li>использования иных функций, доступных в соответствующей версии Сервиса.</li>
                        </ul>

                        <h3>3. Регистрация</h3>
                        <p>Для использования Сервиса Пользователь проходит регистрацию с использованием адреса электронной почты.</p>
                        <p>Пользователь обязуется предоставлять достоверные сведения.</p>
                        <p>Пользователь самостоятельно отвечает за сохранность доступа к своему аккаунту.</p>

                        <h3>4. Права Пользователя</h3>
                        <p>Пользователь вправе:</p>
                        <ul>
                            <li>использовать Сервис в соответствии с его назначением;</li>
                            <li>получать доступ к приобретенным функциям;</li>
                            <li>обращаться в службу поддержки;</li>
                            <li>прекратить использование Сервиса в любое время.</li>
                        </ul>

                        <h3>5. Обязанности Пользователя</h3>
                        <p>Пользователь обязуется:</p>
                        <ul>
                            <li>соблюдать законодательство Российской Федерации;</li>
                            <li>не использовать Сервис для противоправной деятельности;</li>
                            <li>не предпринимать действий, нарушающих работу Сервиса;</li>
                            <li>не получать несанкционированный доступ к данным других пользователей;</li>
                            <li>не использовать автоматизированные средства для массового обращения к Сервису без письменного согласия Оператора.</li>
                        </ul>

                        <h3>6. Права Оператора</h3>
                        <p>Оператор вправе:</p>
                        <ul>
                            <li>изменять функциональность Сервиса;</li>
                            <li>проводить технические работы;</li>
                            <li>временно ограничивать доступ к Сервису;</li>
                            <li>удалять материалы, нарушающие законодательство;</li>
                            <li>блокировать аккаунты при нарушении настоящего Соглашения.</li>
                        </ul>

                        <h3>7. Подписка и платные функции</h3>
                        <p>Отдельные функции Сервиса предоставляются на платной основе.</p>
                        <p>Стоимость подписки определяется тарифами, опубликованными на сайте.</p>
                        <p>После окончания оплаченного периода доступ к платным функциям прекращается, если подписка не продлена.</p>

                        <h3>8. Интеллектуальная собственность</h3>
                        <p>Все права на Сервис, включая:</p>
                        <ul>
                            <li>программный код;</li>
                            <li>дизайн;</li>
                            <li>интерфейс;</li>
                            <li>логотипы;</li>
                            <li>тексты;</li>
                            <li>изображения;</li>
                            <li>документацию,</li>
                        </ul>
                        <p>принадлежат Оператору либо используются на законных основаниях.</p>
                        <p>Пользователь получает ограниченное неисключительное право использования Сервиса.</p>

                        <h3>9. Пользовательский контент</h3>
                        <p>Права на информацию, которую Пользователь самостоятельно размещает в Сервисе, сохраняются за Пользователем.</p>
                        <p>Пользователь предоставляет Оператору право хранить и обрабатывать такой контент исключительно в целях обеспечения работы Сервиса.</p>

                        <h3>10. Ограничение ответственности</h3>
                        <p>Сервис предоставляется по принципу «как есть» ("as is").</p>
                        <p>Оператор не гарантирует:</p>
                        <ul>
                            <li>абсолютное отсутствие ошибок;</li>
                            <li>непрерывную работу Сервиса;</li>
                            <li>достижение Пользователем каких-либо личных, профессиональных либо финансовых результатов вследствие использования Сервиса.</li>
                        </ul>
                        <p>Оператор не несет ответственности за:</p>
                        <ul>
                            <li>действия Пользователя;</li>
                            <li>потерю данных вследствие действий Пользователя;</li>
                            <li>перебои в работе сети Интернет;</li>
                            <li>сбои оборудования Пользователя;</li>
                            <li>действия третьих лиц.</li>
                        </ul>
                        <p>Максимальная ответственность Оператора ограничивается суммой денежных средств, фактически уплаченных Пользователем за последние 12 месяцев использования Сервиса.</p>

                        <h3>11. Обработка персональных данных</h3>
                        <p>Обработка персональных данных осуществляется в соответствии с Политикой обработки персональных данных, размещенной на сайте Сервиса.</p>

                        <h3>12. Изменение условий</h3>
                        <p>Оператор вправе изменять настоящее Соглашение.</p>
                        <p>Новая редакция вступает в силу с момента публикации на сайте, если иное не указано в новой редакции.</p>
                        <p>Продолжение использования Сервиса означает согласие Пользователя с новой редакцией Соглашения.</p>

                        <h3>13. Прекращение использования</h3>
                        <p>Пользователь вправе прекратить использование Сервиса в любое время.</p>
                        <p>Оператор вправе прекратить доступ Пользователя к Сервису в случае нарушения настоящего Соглашения или требований законодательства Российской Федерации.</p>

                        <h3>14. Разрешение споров</h3>
                        <p>Все споры разрешаются путем переговоров.</p>
                        <p>При невозможности достижения соглашения спор подлежит рассмотрению в судебном порядке в соответствии с законодательством Российской Федерации.</p>

                        <h3>15. Заключительные положения</h3>
                        <p>Во всем, что не урегулировано настоящим Соглашением, стороны руководствуются законодательством Российской Федерации.</p>
                        <p>Если отдельные положения настоящего Соглашения будут признаны недействительными, остальные положения сохраняют свою силу.</p>

                        <h3>16. Реквизиты Оператора</h3>
                        <ul>
                            <li><strong>ФИО:</strong> Коледина Антонина Владимировна</li>
                            <li><strong>Статус:</strong> Самозанятый (налог на профессиональный доход)</li>
                            <li><strong>ИНН:</strong> 616 899 406 200</li>
                            <li><strong>E-mail:</strong> staff@insight-systems.ru</li>
                            <li><strong>Дата последнего обновления:</strong> 25.07.2026</li>
                        </ul>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}
